const sections = document.getElementsByClassName('m-tab-content');

class Testimonial {
  constructor(container) {
    this.container = container;
    this.build();
    this.addEventListeners();
  }

  build() {
    const { container } = this;

    this.rows = container.getElementsByClassName('m-tab-content__button');
    this.activeRow = container.querySelector('.is-visible');
    this.activeNavItem = container.querySelector('.is-active');
  }

  addEventListeners() {
    const { rows } = this;

    [].map.call(rows, row => row.addEventListener('click', this.handleRowClick.bind(this)));
  }

  handleRowClick(event) {
    event.preventDefault();
    const { currentTarget } = event;
    const { activeRow, activeNavItem, container } = this;

    if (activeRow) activeRow.classList.remove('is-visible');
    if (activeNavItem) activeNavItem.classList.remove('is-active');

    this.activeRow = container.querySelector(`#${currentTarget.dataset.id}`);
    this.activeNavItem = currentTarget;

    this.activeNavItem.classList.add('is-active');
    this.activeRow.classList.add('is-visible');
  }
}

function initTabContent() {
  [].map.call(sections, section => new Testimonial(section));
}

if (sections) initTabContent();
